import React, { useEffect, useState } from 'react';
import { TableBody, TableCell, TableRow } from '@mui/material';
import { Box } from '@mui/system';
import { PersitedDatePicker, TableCustom } from '../../components/common';
import {
  EditIconButton,
  ViewIconButton,
} from '../../components/common/button/CustomIconButton';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '../../hooks/UseQuery';
import { getMonthYearly } from './helpers/utils';
import ChildHeader from '../../components/ui/ChildHeader';
import axios from 'axios';

const Header = [
  [
    {
      text: '#',
      colspan: 1,
      rowspan: 1,
    },

    {
      text: 'MONTH & YEAR',
      colspan: 1,
      rowspan: 1,
    },
    {
      text: 'ACTION',
      colspan: 1,
      rowspan: 1,
    },
  ],
];

const TableList = () => {
  const [monitoringList, setMoniteringList] = useState<
    { month_year: string }[]
  >([]);
  const navigate = useNavigate();
  const date = useQuery('date');
  useEffect(() => {
    let data = getMonthYearly(date);

    setMoniteringList(data);
  }, [date]);
  return (
    <Box>
      <ChildHeader text="Attendance Resister" />
      <div style={{ display: 'flex', margin: '1rem' }}>
        <Box sx={{ margin: 2 }}>
          <PersitedDatePicker label="Year" views={['year']} />
        </Box>
      </div>
      <TableCustom tableHeaderObj={Header}>
        <TableBody>
          {monitoringList.map((item: any, index) => (
            <React.Fragment>
              <TableRow>
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell align="center">{item.month_year}</TableCell>
                <TableCell align="center">
                  <ViewIconButton
                    tooltipTitle="view"
                    onClick={() => {
                      navigate(
                        `/common/editAttendancResister?isView=true&annual_date=${item.month_year}`,
                      );
                    }}
                  />
                  <EditIconButton
                    tooltipTitle="edit"
                    onClick={async () => {
                      const res = await axios
                        .get(`/api/attendanceResisterRoute/${item.month_year}`)
                        .catch((err) => console.log(err));
                      navigate(
                        `/common/editAttendancResister?isView=false&annual_date=${item.month_year}`,
                      );
                    }}
                  />
                </TableCell>
              </TableRow>
            </React.Fragment>
          ))}
        </TableBody>
      </TableCustom>
    </Box>
  );
};

export default TableList;
